import classNames from "classnames";
import { useDispatch } from "react-redux";
import { setShowCart } from "redux/SingleDataset/actions";

import ChevronIcon from "assets/icons/ChevronIcon";
import NotesIcon from "assets/icons/NotesIcon";
import styles from "./style.module.scss";

const SelectionBox = ({ exportCount, showCart }: any) => {
  const dispatch = useDispatch();

  const selectionBoxClassnames = classNames(styles.selectionBox, {
    [styles.boxWithData]: exportCount > 0,
  });

  const toggleIsOpen = () => {
    dispatch(setShowCart(!showCart));
  };

  return (
    <div
      onClick={toggleIsOpen}
      data-tooltip-place="left"
      className={selectionBoxClassnames}
      data-tooltip-id="export-selection-count-box"
    >
      <div className={styles.selectionCountIcon}>
        <NotesIcon />
      </div>
      <span className={styles.selectionTitle}>
        Selected Items {`(${exportCount})`}
      </span>
      <div
        className={classNames(styles.chevronIcon, {
          [styles.disabledIconColor]: exportCount <= 0,
        })}
      >
        {showCart ? (
          <ChevronIcon direction="up" />
        ) : (
          <ChevronIcon direction="down" />
        )}
      </div>
    </div>
  );
};
export default SelectionBox;
